import { Container, Row, Col } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Progress, UiKits } from "../../../Constant";
import { BasicProgressBarsCart } from "./BasicProgressBars";
import { ProgressBarsStripedCart } from "./ProgressBarsStriped";
import { ProgressBarsAnimatedCart } from "./ProgressBarsAnimated";
import { MultipleBarsCart } from "./MultipleBars";
import { ProgressWithNumberStepsCart } from "./ProgressWithNumberSteps";
import { CustomProgressBarsCart } from "./CustomProgressBars";
import { SmallProgressBarsCart } from "./SmallProgressBars";
import { LargeProgressBarsCart } from "./LargeProgressBars";
import { CustomHeightProgressBarsCart } from "./CustomHeightProgressBars";

const ProgressContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={Progress} parent={UiKits} title={Progress} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <BasicProgressBarsCart/>
            <Row>
              <ProgressBarsStripedCart/>
              <ProgressBarsAnimatedCart/>
            </Row>
            <Row>
              <MultipleBarsCart/>
              <ProgressWithNumberStepsCart/>
            </Row>
            <CustomProgressBarsCart/>
            <Row>
              <SmallProgressBarsCart/>
              <LargeProgressBarsCart/>
            </Row>
            <CustomHeightProgressBarsCart/>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ProgressContainer;
